import { HTMLProps } from 'react';
import styled from '@emotion/styled';
import {
  maxHeight,
  MaxHeightProps,
  space,
  SpaceProps,
  themeGet,
  variant,
} from 'styled-system';

type DividerSSProps = SpaceProps &
  MaxHeightProps & { orientation?: 'horizontal' | 'vertical' };
type DividerHTMLProps = Omit<HTMLProps<HTMLHRElement>, keyof DividerSSProps>;
export type DividerProps = DividerSSProps & DividerHTMLProps;

const dividerStyles = variant({
  key: 'dividerStyles',
  prop: 'orientation',
});

const StyledDivider = styled.hr`
  border: 0;
  ${dividerStyles}
  border-color: ${themeGet('colors.greys.alto')};
  margin: 0;
  ${space}
  ${maxHeight}
`;

const Divider = (props: DividerProps) => (
  <StyledDivider orientation="horizontal" {...props} />
);

export default Divider;
